//CSS
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-theme.css';
import 'angular-loading-bar/build/loading-bar.css';
import 'angular-growl-v2/build/angular-growl.css';
import 'sweetalert/dist/sweetalert.css';
import 'font-awesome/css/font-awesome.css';
import 'textangular/src/textAngular.css';
import 'ng-tags-input/build/ng-tags-input.min.css';
import 'ng-tags-input/build/ng-tags-input.bootstrap.min.css';
import 'ui-select/dist/select.min.css';
import '../css/ocom.css';
import '../css/styles.css';

//Vendor
import 'jquery';
import 'moment/moment.js';
import 'moment/locale/en-au.js';
import 'moment-timezone/builds/moment-timezone-with-data.min.js';
import 'bootstrap/dist/js/bootstrap.min.js';
import 'angular';
import '@uirouter/angularjs';
import 'angular-messages';
import 'angular-animate';
import 'angular-resource';
import 'angular-loading-bar';
import 'angular-ui-bootstrap/dist/ui-bootstrap.js';
import 'angular-ui-bootstrap/dist/ui-bootstrap-tpls.js';
import 'angular-strap/dist/angular-strap.min.js';
import 'angular-strap/dist/angular-strap.tpl.min.js';
import 'angular-growl-v2/build/angular-growl.min.js';
import 'sweetalert/dist/sweetalert.min.js';
import 'angular-sweetalert/SweetAlert.min.js';
import 'angular-sanitize/angular-sanitize.min.js';
import 'ngstorage/ngStorage.min.js';
import 'angular-moment/angular-moment.min.js';
import 'angular-jwt';
import 'ng-file-upload/dist/ng-file-upload.min.js';
import 'ng-file-upload/dist/ng-file-upload-all.min.js';
import 'angular-ui-date/dist/date.js';
import 'angular-ui-sortable/dist/sortable.min.js';
import 'textangular/dist/textAngular-rangy.min.js';
import 'textangular/dist/textAngular-sanitize.min.js';
import 'textangular/dist/textAngular.min.js';
import 'ng-dexie/build/ng-dexie.min.js';
import 'html2canvas/dist/html2canvas.min.js';
import 'angular-filter/dist/angular-filter.min.js';
import 'ng-tags-input/build/ng-tags-input.min.js';
import 'ui-select/dist/select.min.js';
import 'angular-xeditable/dist/js/xeditable.js';
